/**
 * NOTE: L'objet wmuwpb est initialisé dans /includes/front/front.php
 */

/**
 * 
 */
const getCurrentViewport = () =>
{
    for ( const key of Object.getOwnPropertyNames( wmuwpb.attributeSwitcher.viewports ) )
    {
        if ( window.innerWidth > wmuwpb.attributeSwitcher.viewports[ key ].widthMin && window.innerWidth <= wmuwpb.attributeSwitcher.viewports[ key ].widthMax )
        {
            return key;
        }
    }

    return wmuwpb.attributeSwitcher.defaultViewport;
}

/**
 * 
 */
const applyViewport = ( viewport ) =>
{
    const viewportLC = viewport.toLowerCase();
    
    [].forEach.call( document.querySelectorAll( `[${viewportLC}-style]` ), ( element ) =>
    {
        element.setAttribute( 'style', element.getAttribute( `${viewportLC}-style` ) );
    } );
    
    // Clean up style attribute for styled element in previous viewport which have no style for the new viewport
    if ( wmuwpb.attributeSwitcher.currentViewport )
    {
        [].forEach.call( document.querySelectorAll( `[${wmuwpb.attributeSwitcher.currentViewport}-style]:not([${viewportLC}-style])` ), ( element ) =>
        {
            element.removeAttribute( 'style' );
        } );
    }

    wmuwpb.attributeSwitcher.currentViewport = viewport;
}

/**
 * 
 */
window.addEventListener( 'resize', ( event ) =>
{
    const currentViewport = getCurrentViewport();

    if ( currentViewport !== wmuwpb.attributeSwitcher.currentViewport )
    {
        const event = new CustomEvent( 'WMUViewportChange', { 
            detail: {
                currentViewport: currentViewport,
                previousViewport: wmuwpb.attributeSwitcher.currentViewport
            }
        } );
        document.dispatchEvent( event );

        applyViewport( currentViewport );
    }
} );

/**
 * 
 */
document.addEventListener( 'DOMContentLoaded', ( event ) =>
{
    applyViewport( getCurrentViewport() );
} );